import { createAsyncAction } from 'typesafe-actions'

export const getExportLogs = createAsyncAction(
  'Get_Export_Logs__Request',
  'Get_Export_Logs__Success',
  'Get_Export_Logs__Failure',
)<void, any, Error>()
